import React from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import { clientsHero } from '../assets/images/imageImports';

const WhoItsFor = () => {
  return (
    <div className="who-its-for-page">
      <Hero
        title="Who We Serve"
        subtitle="Tailored solutions for businesses at every stage"
        buttonText="Case Studies"
        buttonLink="/what-we-build"
        backgroundImage={clientsHero}
      />
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Clients</h2>
          
          <div className="row">
            <div className="col-4">
              <div className="card">
                <div className="card-icon">🚀</div>
                <h3 className="card-title">Founder-Led Firms</h3>
                <div className="card-content">
                  <h4>Ready to Scale or Sell?</h4>
                  <p>At SkySight Analytics, we specialize in helping ambitious founders take control of their numbers—whether you're preparing for a sale, raising your next round, or scaling fast.</p>
                  
                  <h4>With ExitReady™, you get:</h4>
                  <ul>
                    <li>A centralized finance data warehouse across ERP, CRM, payroll, and BI systems</li>
                    <li>Clean, reconciled reporting for revenue, margins, CAC, LTV, retention, and more</li>
                    <li>Data room–ready dashboards and export packages</li>
                    <li>A story buyers and investors can trust</li>
                  </ul>
                  
                  <h4>With ScalePath™, we help you:</h4>
                  <ul>
                    <li>Choose, design and implement scalable ERP, FP&A and data systems</li>
                    <li>Automate reporting, forecasting and accelerate month-end close</li>
                    <li>Scale-up, avoiding the growing pains of outgrowing spreadsheets and duct-taped systems</li>
                  </ul>
                  
                  <Button to="/why-exit-ready" type="primary" style={{marginTop: '1rem'}}>Learn More</Button>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card">
                <div className="card-icon">💼</div>
                <h3 className="card-title">PE-Backed Firms</h3>
                <div className="card-content">
                  <h4>Empower Your Portfolio Companies</h4>
                  <p>SkySight Analytics provides fractional operating partner support for private equity firms to professionalize the finance and data stack of their portfolio companies—helping them scale smarter, avoid valuation drag, and accelerate outcomes.</p>
                  
                  <h4>With ScalePath™, your PortCos gain:</h4>
                  <ul>
                    <li>Finance tech stack advisory and ERP/FP&A/BI implementation</li>
                    <li>Automated reporting, dashboards, and faster month-end close</li>
                    <li>Defined operating metrics for board-level visibility</li>
                    <li>Data governance and KPI alignment across business units</li>
                  </ul>
                  
                  <h4>With ExitReady™, you get:</h4>
                  <ul>
                    <li>A reconciled finance data warehouse integrating ERP, CRM, payroll, and BI</li>
                    <li>Audit-ready views of ARR, CAC, margin, retention, cohort and revenue metrics</li>
                    <li>Data room–aligned outputs for investor diligence</li>
                    <li>Risk mitigation for data red flags that erode value</li>
                  </ul>
                  
                  <Button to="/whats-included" type="primary" style={{marginTop: '1rem'}}>Learn More</Button>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card">
                <div className="card-icon">🔹</div>
                <h3 className="card-title">M&A Advisors - Sell Side</h3>
                <div className="card-content">
                  <h4>Maximize Client Valuations with Clean Data</h4>
                  <p>At SkySight Analytics, we partner with M&A advisors and investment bankers to ensure your clients' data tells a compelling, credible story that maximizes valuation and accelerates deal execution.</p>
                  
                  <h4>ScalePath™ helps your clients:</h4>
                  <ul>
                    <li>Implement investor-grade ERP and reporting systems before going to market</li>
                    <li>Establish clean KPIs and metrics that buyers trust and value</li>
                    <li>Automate board reporting and create executive dashboards for due diligence</li>
                    <li>Build scalable infrastructure that supports growth without operational friction</li>
                  </ul>
                  
                  <h4>ExitReady™ ensures:</h4>
                  <ul>
                    <li>Data room-ready financials that eliminate buyer concerns and delays</li>
                    <li>Reconciled metrics across all systems for consistent storytelling</li>
                    <li>Clean, auditable data that supports premium valuations</li>
                    <li>Faster due diligence cycles and reduced deal risk</li>
                  </ul>
                  
                  <Button to="/what-we-build" type="primary" style={{marginTop: '1rem'}}>Learn More</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Why Choose SkySight Analytics?</h2>
          <div className="row">
            <div className="col-6">
              <h3>For Founder-Led Firms:</h3>
              <ul className="check-list">
                <li>Deep experience in finance + data across dozens of founder-led success stories</li>
                <li>Built for small to mid-cap companies scaling fast or preparing for sale</li>
                <li>Flexible engagement models and hands-on execution</li>
              </ul>
            </div>
            <div className="col-6">
              <h3>For PE Firms:</h3>
              <ul className="check-list">
                <li>Deep experience working with PE-backed firms and exit planning</li>
                <li>System-agnostic, finance-first guidance with a proven track record</li>
                <li>Helps your team avoid costly delays, discounting, or capability gaps during hold</li>
                <li>Boutique execution—no bloated advisory teams or PowerPoint deliverables</li>
              </ul>
            </div>
          </div>
          <div className="text-center" style={{marginTop: '2rem'}}>
            <Button to="/contact" type="primary" size="large">Contact Us</Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhoItsFor;